<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName"></div>
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
              :option="option"
              :drillClickList="drillClickList"
              :drillDimList="drillDimList"></ChartNav>
    <Pagenation :thisArg="thisArg"></Pagenation>
  </div>
</template>

<script>
import create from "../../create";
import {CHART_TYPE} from "@/option/common/dict";
import util from "@/option/common/util";
import {unref} from "vue";
// _dOriginVal: _el[this.dcode]._originVal
export default create({
  name: "bar",
  methods: {
    updateChart() {
      const optionData = this.deepClone(this.dataChart);
      let option = {
        dataZoom: this.getDataZoom(),
        title: this.getOptionTitle(),
        tooltip: this.getOptionTip({
          trigger: "axis",
          confine: true
        }),
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(),
        xAxis: this.getXAxisOption({
          data: optionData?.categories || [],
        }),
        yAxis: this.getYAxisOption({
          min: this.option.yAxisMinAuto ? null : this.option.yAxisMin,
          max: this.option.yAxisMaxAuto ? null : this.option.yAxisMax,
          interval: this.option.yAxisIntervalAuto ? null : this.option.yAxisInterval,
          minInterval: this.option.yAxisminInterval,
          data: optionData?.categories || [],
        }),
        series: (() => {
          const barColor = this.option.barColor || [];
          const list = (optionData?.series || []).map((ele, index) => {
            return Object.assign(ele, {
              type: "bar",
              stack: ele.stack,
              barWidth: this.option.barWidth || 16,
              barMinHeight: this.option.barMinHeight || 0,
              itemStyle: this.getHasProp(
                  !this.switchTheme,
                  {
                    color: this.getColor(index),
                  },
                  {barBorderRadius: this.option.barRadius || 0}
              ),
              label: this.getOptionLabel({
                position: this.option.labelPosition,
              }),
            });
          });
          return list;
        })(),
      };
      if (this.isDataCenter) {
        let _op = this.getDimentionOption();
        option.yAxis.data = _op.categories;
        option.xAxis.data = _op.categories;
        option.legend = this.getOptionLegend(_op.series);
        option.series = _op.series.map((el, index) => {
          return {
            ...el,
            type: "bar",
            stack: el.stack,
            barWidth: this.option.barWidth || 16,
            barMinHeight: this.option.barMinHeight || 0,
            itemStyle: this.getHasProp(
                !this.switchTheme,
                {
                  color: this.getColor(index),
                },
                {barBorderRadius: this.option.barRadius || 0}
            ),
            label: this.getOptionLabel({
              position: this.option.labelPosition,
            }),
            markLine: {
              ...this.getMarkLineDefaultSet(),
              lineStyle: {
                width: this.option.yAxisMarkLineWidth || 1,
                type: this.option.yAxisMarkLineType,
                color: this.option.yAxisMarkLineColor || "#FF0000",
              },
              data: this.option.yAxisMarkLineShow && this.getMarklineOption()
            }
          };
        });
      }
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    },
  },
});
</script>
